import type { ProductDto } from '@gc/shared';

/**
 * A menu product as the API now sends it. `hasRecipe` rides on the wire ahead
 * of the shared contract (the API widens its DTO locally); an older server
 * leaves it out, which reads as "no recipe" — the rule the till had before.
 */
export type TillProduct = ProductDto & { hasRecipe?: boolean };

/**
 * Whether the till greys a tile out as "Sold out".
 *
 * The SERVER's rule, and nothing else, because this used to be a second opinion
 * that disagreed with it three ways (audit, 2026-09-23):
 *
 *  - a tracked product WITH a recipe sells from raw items, and its own count
 *    (usually 0) is inert — `OrdersService.create` never refuses it, yet the
 *    till called it Sold out;
 *  - a tracked SERVICE at 0 WAS offered, then refused with insufficient_stock:
 *    the SERVICE opt-out died on the server (`trackStock` is the one authority)
 *    and lived on here;
 *  - a RETURN puts stock back and is exempt server-side, but the tile was
 *    disabled anyway — so the item that had just sold out could not be returned.
 *
 * An untracked product ("No stock") still never reads sold out: its count is
 * one nobody keeps.
 */
export function isSoldOut(product: TillProduct, options: { isReturn: boolean }): boolean {
  if (options.isReturn) return false;
  return product.trackStock && !product.hasRecipe && product.stockQuantity <= 0;
}
